/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import SubmitButton from '../../components/buttons/SubmitButton/';
import { ElementTypeActions } from '../../actions/elementType'
import { validateAndDispatch } from '../../helpers/form';
import {Map} from 'immutable';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import InputField from '../form/InputField';
// import './CreateProjectButton.css';

const renameElementTypePropFormSelector = (state) => {
  const selector = formValueSelector('renameElementTypeProp');
  return selector(
    state,
    'elementTypePropName'
  );
};

const modalSelector = (state) => state.modal.get('modals').last();
const elementTypesSelector = (state) => state.elementTypes.get('elementTypes');
const elementTypeIdSelector = (state) => {
  const modal = modalSelector(state);
  return modal.getIn(['options', 'elementTypeId']);
};

const RenameElementTypePropertySelector = immutableCreatorSelector(
  [
    modalSelector,
    elementTypesSelector,
    elementTypeIdSelector,
    renameElementTypePropFormSelector
  ],
  (
    modal,
    elementTypes,
    elementTypeId,
    renameElementTypePropForm
  ) => ({
    modal,
    elementTypes,
    elementTypeId,
    renameElementTypePropForm,
    initialValues: {
      elementTypePropName: modal.getIn(['options', 'elementTypePropName'])
    }
  })
);

@connect(RenameElementTypePropertySelector)
@reduxForm({
  form: 'renameElementTypeProperty',
  destroyOnUnmount: false
})

export default class RenameElementTypePropertyModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool.isRequired,
    elementTypes: PropTypes.instanceOf(Map).isRequired,
    modal: PropTypes.instanceOf(Map),
    elementTypeId: PropTypes.string,
    reset: PropTypes.func
  }

  submit = (values, dispatch) => {
    console.log('values', values);
    const {
      reset,
      modal,
      elementTypeId
    } = this.props;

    const currentProp = modal.getIn(['options', 'elementTypePropName']);
    const renamePropertyObject = {
      elementTypeId,
      prop: currentProp,
      newPropKey: values.elementTypePropName,
    };

    const validation = {
      elementTypePropName: [{ rule: 'required', label: 'property name' }],
    };

    return validateAndDispatch(
      dispatch,
      ElementTypeActions.renameElementTypeProperty(renamePropertyObject),
      validation,
      values
    ).then(() => {
      reset();
    });
  }

  render() {
    const {
      handleSubmit,
      submitting
    } = this.props;

    return (
      <div className="fs-modal-content">
        <h4>Rename Element Type Property</h4>
        <form>
          <div className="modal-form-wrapper">
            <div className="form-group row mb-2">
              <label className="col-sm-3 col-form-label">Property Name</label>
              <div className="col-sm-9">
                <Field
                  name="elementTypePropName"
                  type="input"
                  component={InputField}
                  className="form-control"
                  wrapperClassName="form-group row"
                  labelClassName="col-sm-2 col-form-label"
                  containerClassName="col-sm-10"
                  placeholder="Property Name"
                  style={{ marginBottom: 10 }}
                  autoFocus
                />
              </div>
            </div>
          </div>
          <div className="modal-form-button-wrapper">
            <SubmitButton
              submitting={submitting}
              onClick={handleSubmit(this.submit)}
            >Rename</SubmitButton>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/RenameElementTypePropertyModal.js